import createMailboxExportRequest from '../services/createMailboxExportRequest';
import { orchestrator } from 'satcheljs';
import setIsExportMailboxRequestMade from '../mutators/setIsExportMailboxRequestMade';
import requestMailboxExport from '../actions/requestMailboxExport';
import getStore from '../store/store';
import deleteMailboxExportRequest from '../services/deleteMailboxExportRequest';
import setExportLink from '../mutators/setExportLink';
import setExportStatus from '../mutators/setExportStatus';

export default orchestrator(requestMailboxExport, async () => {
    setIsExportMailboxRequestMade(true);
    if (getStore().downloadLink) {
        // The user is requesting a re-export, so we need to delete the previous request.
        setExportLink(undefined);
        setExportStatus(undefined);
        await deleteMailboxExportRequest();
    }
    await createMailboxExportRequest();
});
